import type { CheckoutError } from '@/lib/types';

interface Props {
  error: CheckoutError;
}

const ERROR_MESSAGES: Record<string, string> = {
  NOT_FOUND: 'Esta sesión de pago no existe o ya no está disponible.',
  UNAUTHORIZED: 'No tienes acceso a esta sesión de pago. Vuelve a la tienda.',
  EXPIRED: 'Esta sesión de pago ha expirado. Regresa a la tienda para iniciar uno nuevo.',
  NETWORK_ERROR: 'No pudimos conectar con el servidor. Verifica tu conexión a internet.',
};

function userMessage(error: CheckoutError): string {
  return (
    ERROR_MESSAGES[error.code] ??
    'No pudimos cargar la página de pago. Por favor regresa a la tienda e intenta de nuevo.'
  );
}

export function LoadError({ error }: Props) {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-gray-100 p-8 text-center">
        <div className="flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mx-auto mb-6">
          <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>

        <h2 className="text-xl font-bold text-gray-900 mb-2">No se pudo cargar</h2>
        <p className="text-gray-500 mb-6">{userMessage(error)}</p>

        <p className="text-xs text-gray-400">
          Si el problema persiste, contacta al comercio o al soporte.
        </p>
      </div>
    </div>
  );
}
